/* eslint-disable check-file/filename-blocklist */
import type { PropsWithChildren, ReactNode } from 'react';

export const PAGES_TABLE_CONFIRMATION_SOURCE = 'publicLinksPagesActionConfirmationModal';

export enum ChangeboardingTypes {
	INTRODUCTION = 'introduction',
	TOGGLE_SPOTLIGHT = 'toggle-spotlight',
	MENU_SPOTLIGHT = 'menu-spotlight',
	NONE = 'none',
}

export const SET_UP_AND_MANAGE_DOCUMENTATION =
	'https://support.atlassian.com/confluence-cloud/docs/set-up-and-manage-public-links/';
export const DATA_SECURITY_POLICY_DOCUMENTATION =
	'https://support.atlassian.com/security-and-access-policies/docs/prevent-public-links/';
export const PUBLIC_LINKS_SECURITY_DOCUMENTATION =
	'https://support.atlassian.com/confluence-cloud/docs/how-secure-are-public-links/';
export const LEARN_MORE_PUBLIC_LINKS_HREF =
	'https://support.atlassian.com/confluence-cloud/docs/share-content-externally-with-public-links/';

type TrackEventInfoType = {
	actionSubjectId: string;
	source: string;
	attributes?: Object;
};

type SpotlightMessagesType = {
	spotlightHeading?: string;
	spotlightBody: string;
};

type DialogPlacementType =
	| 'top left'
	| 'top center'
	| 'top right'
	| 'right top'
	| 'right middle'
	| 'right bottom'
	| 'bottom left'
	| 'bottom center'
	| 'bottom right'
	| 'left top'
	| 'left middle'
	| 'left bottom';

export type SpotlightWrapperProps = PropsWithChildren<{
	spotlightTarget: string;
	spotlightMessages: SpotlightMessagesType;
	analyticsInfo: TrackEventInfoType;
	dialogWidth: number;
	dialogPlacement: DialogPlacementType;
	isChainedEvent?: boolean;
	buttonLabel?: ReactNode;
	onClose?: VoidFunction;
}>;
